<template>
  <a-divider orientation="left">设备配置信息</a-divider>
  <a-descriptions :column="6" layout="vertical" bordered>
    <a-descriptions-item  v-for="(item,index) in single.identityPark" :key="index" :label="index">
      <span v-if="index === '红绿灯颜色'">
        <span style="width: 40px;height: 40px;display: block;" :style="{background:item}"></span>
      </span>
      <span v-else-if="item.constructor !== Array">{{item + '\n'}}</span>
      <template v-else>
        <span v-for="(item2,index2) in item" :key="index2">
          <template v-if="item2.constructor !== Object">{{item2 + '\n'}}</template>
          <template v-else>
            <span v-for="(item3,index3) in item2" :key="index3">
              <template v-if="index3 === 'park_id'">[park_id]:{{item3 + '\n'}}</template>
              <template v-if="index3 === 'park_no'">[park_no]:{{item3 + '\n'}}</template>
            </span>
          </template>
        </span>
      </template>
    </a-descriptions-item>
  </a-descriptions>
</template>
<script setup>
import singleDev from "@/stores/singleDev";
let single = singleDev();
console.log(single.identityPark)
</script>

<style scoped lang="scss">

</style>
